/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const Content = styled.div`
  width: 650px;
  display: flex;
  flex-direction: column;
  padding: 24px;
`;

export const TableRow = styled.div`
  border: 1px solid ${Palette.PrimaryGray._200};
  border-bottom: none;
  display: flex;
  align-items: center;
  background: ${Palette.PrimaryGray._000};
  padding-right: 16px;
  width: 100%;
`;

export const ItemsContainer = styled.div`
  width: 100%;
  border: 1px solid ${Palette.PrimaryGray._200};
  max-height: 290px;
  overflow-y: auto;
  border-bottom: ${({ isEmpty }) => isEmpty && 'unset'};
  ::-webkit-scrollbar {
    width: 6px;
    background-color: #fff;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;
export const CampaignItem = styled.div`
  display: flex;
  height: 72px;
  border-bottom: ${({ isLastItem }) => !isLastItem && `1px solid ${Palette.PrimaryGray._200}`};
`;

export const IconBlock = styled.div`
  padding: 24px 16px 24px 16px;
  width: 56px;
`;

export const TextBlock = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  text-align: left;
`;
